(function (ws, win) {
    'use strict';
    ws.views.reqRevisionPage = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote_activity',
        GTM_EVENT_ACTION: 'request_revision',
        GTM_EVENT_DETAIL_ACTION: 'quote_details',
        GTM_EVENT_CONVERT_TO_ORDER_ACTION: 'convert_to_order',

        convQuoteToOrderUrl: globals.path.api.westcon.quoteToOrderUrl,
        quoteToTransferUrl: globals.path.api.westcon.quoteToTransferUrl,

        events: {
            'click .qdf-submit-dd': 'selectAction',
            'change #primary-quote-checkbox': 'hideMessage',
            'change .crr-select-action': 'checkValidate',
            'click .latestMsgUpdateQuote': 'pushLatestMessageFunction'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.openCommentModalId = this.$('.crr-select-action').attr('data-modalCart');
            this.$selectOption = this.$('.crr-select-action');
            this.$budgetaryWarn = this.$('.qut-budgetary-warn');
            this.$goButton = this.$('.qdf-submit-dd');

            if (localStorage.getItem('quoteActivity') == '1') {
                this.quoteActivityCapture();
                localStorage.setItem('quoteActivity', '2');
            }

            this.validateEntries = new ws.models.formValidateEntries();
            this.validateEntries.set({
                quoteId: this.$('[name=code]').val(),
                versionId: this.$('[name=versionID]').val()
            });

            this.sapOrderDate = this.$('#sapOrderDate').val();
            this.releaseDate = '14/12/2019';

            if (!moment(this.releaseDate, dateFormat, true).isBefore(moment(this.sapOrderDate, dateFormat, true))) {
                this.$('.vatPrice').hide();
                this.$('.totalValueLabel').html(this.$('.totalValueLabel').html().trim().split('(')[0]);
            }

            this.checkValidateEntries();
        },

        hideMessage: function () {
            this.$('.checkbox-error-message').addClass('hide');
        },
        /*
        * Telstra Latest Message
        * */
        pushLatestMessageFunction: function() {
            $.ajax({
                url: globals.path.api.westcon.getLatestMessageTelstraForQuote + $('.quoteID').val() + '?' + CSRF,
                contentType: 'application/json',
                data: {},
                method: 'POST'
            }).done(function (response) {
                if (response.success) {
                    $('.showSuccessMessage').css({display:'block'}).fadeOut(5000);
                } else {
                    $('.showErrorMessage').css({display:'block'}).fadeOut(5000);
                }
            }.bind(this)).fail(function (e) {
                console.log('error', e);
            });
        },

        /**
         * check the validate entries
         */
        checkValidateEntries: function () {
            this.validateEntries.fetch().done(function (response) {
                if (response.length) {
                    let errorString = '<ul>';
                    _.each(response, function (error) {
                        errorString += '<li>' + error + '</li>';
                    });
                    errorString += '</ul>';
                    this.$('.qut-validate-entries-error').html(errorString);
                }
            }.bind(this));
        },

        checkValidate: function () {
            if ((this.$selectOption.val() === 'convOrder') && (this.$('.qut-validate-entries-error').children().length)) {
                this.$('.qut-validate-entries-error').removeClass('hide');
                this.$goButton.prop('disabled', true);
            } else {
                this.$('.qut-validate-entries-error').addClass('hide');
                this.$goButton.prop('disabled', false);
            }
        },

        /**
         * select Action
         * @param {Object} e
         */
        selectAction: function (e) {
            e.preventDefault();
            let tabNum = this.$(e.currentTarget).data('tabNumber');
            tabNum = tabNum ? tabNum : '';
            this.$(`#primaryQuoteErrMsg${tabNum}`).addClass('hide');
            var query = this.$selectOption.val();
            if (query === 'revRequest') {
                this.eventAgg.trigger(this.openCommentModalId);
            } else if (query === 'convOrder') {
                if (this.$budgetaryWarn.val() != undefined) {
                    this.$budgetaryWarn.show();
                } else {
                    var quoteID = this.$('.quoteID').val();
                    var versionID = this.$('.versionID').val();
                    this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_CONVERT_TO_ORDER_ACTION);
                    win.location = this.convQuoteToOrderUrl + '/' + quoteID + '/' + versionID;
                }
            } else if (query === 'allowTransfer') {
                let quoteIDTransfer = this.$('.quoteID').val();
                let versionIDTransfer = this.$('.versionID').val();
                win.location = this.quoteToTransferUrl + '/' + quoteIDTransfer + '/' + versionIDTransfer;
            } else if (query === 'confirmPrimaryQuote') {
                if (this.$(`#primary-quote-checkbox${tabNum}`).is(':checked')) {
                    let quoteID = this.$(`.quoteID${tabNum}`).val();
                    let versionID = this.$(`.versionID${tabNum}`).val();
                    this.eventAgg.trigger('primaryQuoteModal', quoteID, versionID);
                } else {
                    this.$(`#primaryQuoteErrMsg${tabNum}`).removeClass('hide');
                }
            }
        },

        // Send tracking data to Google Analytics
        quoteActivityCapture () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_DETAIL_ACTION);
        }

    });
})(westcon, window);
